<ng-container [formGroup]="model">
  <div class="property">
    <span>Kolor</span>
    <div class="container">
      <input
        #me
        [cpUseRootViewContainer]="true"
        (colorPickerChange)="model.patchValue({ color: $event })"
        [(colorPicker)]="model.value.color"
        [style.background]="model.value.color"
      />
    </div>
  </div>
  <div>
    <app-change-number [minNumber]="-20" formControlName="shiftX"
      >Przesunięcie w poziomie
    </app-change-number>
  </div>
  <div>
    <app-change-number [minNumber]="-20" formControlName="shiftY"
      >Przesunięcie w pionie
    </app-change-number>
  </div>
  <div>
    <app-change-number [minNumber]="-20" formControlName="spread"
      >Rozproszenie
    </app-change-number>
  </div>
  <div>
    <app-change-number [minNumber]="-20" formControlName="blur"
      >Rozmycie
    </app-change-number>
  </div>
</ng-container>
